import Button from '@/components/shared/Button';
import { ArrowLeftIcon, ArrowRightIcon } from '@/icons';

type ArrowsProps = {
  onPrevious: () => void;
  onNext: () => void;
};

export const Arrows = ({ onNext, onPrevious }: ArrowsProps) => {
  return (
    <div className="hidden flex-row gap-4 lg:flex">
      <Button variant="light" outline onClick={onPrevious} className="p-4">
        <ArrowLeftIcon />
      </Button>
      <Button variant="light" outline onClick={onNext} className="p-4">
        <ArrowRightIcon />
      </Button>
    </div>
  );
};
